import translation_en from "./translation/en.json";

export const resources = {
    en: { translation: translation_en }
};